module.exports = __webpack_public_path__ + "img/78.14853d3e.jpg";